import type { File } from '@openapi'

/**
 * @deprecated - not used anymore
 */
export function fetchDocumentInfo(payload: { fileId: File['id'] }): Promise<{
  pageCount: number
  [key: string]: unknown
}> {
  return this.API.request('fetch_document_info', payload)
}

/**
 * Renders a page from a file together with annotations.
 *
 * @example
 * api.renderPageAsImage({
 *   fileId: '123456',
 *   documentId: '654321',
 *   pageIndex: 0,
 *   params: { width: 1920 },
 * })
 *
 * @returns A promise that resolves with the image as an ArrayBuffer.
 */
export function renderPageAsImage(payload: {
  /**
   * The ID of the file to render. Used when the documentId is not available.
   */
  fileId: File['id']
  /**
   * The ID of the document to render (optional). If not provided the fileId will be used.
   */
  documentId?: File['id']
  /**
   * The index of the page to render.
   */
  pageIndex: number
  /**
   * The parameters to use for rendering the page.
   */
  params: { width: number } | { height: number }
}): Promise<ArrayBuffer> {
  return this.API.request('render_page_as_image', payload)
}
